export default __webpack_public_path__ + "static/media/2025-hero-1.77e3d0c2.webp";